
const isVarMsg = o => o[0].var && o[0].var.length > 0;
const isExpMsg = o => !!o[0].exp;

const baseURL = !process.env.NODE_ENV || process.env.NODE_ENV === 'development' ?
    'http://localhost:8080' : window.location.origin.toString();

// eslint-disable-next-line
const handleResponse = (r) => {
    if (r.ok) {
        return r
            .json()
            .then(v => {
                let obj = { data: {} };
                if (v !== null && typeof v === "object") {
                    obj = v;
                } else {
                    console.warn("Received unrecognized response from backend: ", v);
                }
                return Promise.resolve(obj);
            })
            .catch(e => {
                console.log("json.catch", e);
                return Promise.resolve({ data: {} });
            });
    } else {
        return r.json().then(
            v => {
                if (v !== null && typeof v === "object" && v.dtl) {
                    let obj = {};
                    if (isVarMsg(v.dtl)) {
                        let msg = v.dtl[0].msg;
                        for (let value of v.dtl[0].var) {
                            const val = value.v || value.val;
                            msg = msg.replace(
                                "{" + value.fld + "}",
                                val && typeof val === "string"
                                    ? "::ERROR::"
                                    : val
                            );
                        }
                        obj.message = msg;
                    } else if (isExpMsg(v.dtl)) {
                        obj.message = v.dtl[0].exp;
                    }
                    throw obj;
                }
                throw v;
            },
            e => {
                throw r;
            }
        );
    }
    //throw r;
};

//eslint-disable-next-line
export default class API {
    /**
     * Given a user name and password, invoke the login API on AOS
     * and if the login is a success resolve to the correct view-scope for the logged in user.
     * returns: a Promise that resolves to
     * {
     *  success: true | false
     *  viewScope: String (optional only in success case)
     * }
     */
    // eslint-disable-next-line
    static login = (username, password) => {
        const headers = new Headers();
        headers.set("Content-Type", "application/json");

        const body = {
            userName: username,
            password: password
        }

        const fetchOptions = {
            method: "POST",
            headers,
            body: JSON.stringify(body),
            credentials: "include"
        };

        const target = `${baseURL}/login`;

        //eslint-disable-next-line
        return fetch(target, fetchOptions)
            .then((response) => handleResponse(response));
    };

    // eslint-disable-next-line
    static logout = () => {
        return fetch(`${baseURL}/api/logout`,
            { method: "GET", credentials: "include" })
            .then(handleResponse);
    };

    /**
     * Given an entity target, go fetch.
     * Parse the response and resolve to a JSON object representing the entity,
     * If the fetch failed then throw an exception
     */
    // eslint-disable-next-line
    static fetchEntity = (target, options) => {
        const url = `${baseURL}/${target}`;
        return fetch(url, { ...options, credentials: "include" }).then(handleResponse)
            .catch(e => {
                if (String(e) === "TypeError: Failed to fetch") {
                    // logout
                    localStorage.clear();
                } else {
                    throw e;
                }
            });
    };

    /**
     *
     */
    // eslint-disable-next-line
    static whoami = () => {
        return fetch(`${baseURL}/users/me`,
            { method: "GET", credentials: "include" })
            .then(handleResponse);
    };
}
